export default class Converter {
  static hexToRgbA(hex: string, opacity: number) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? `rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, ${opacity})`
      : null;
  }

  static getObjectDotsKeys(obj: any, prefix?: string | null): any {
    const flatMap = (a: any[], cb: (v: any, i: number) => any) => [].concat(...a.map(cb));
    if (typeof obj !== 'object') throw new Error('Invalid argument, must be an object');
    return flatMap(Object.keys(obj), (key) => {
      const value = obj[key];
      const fullKey = prefix ? `${prefix}.${key}` : key;

      if (Array.isArray(value)) {
        return flatMap(value, (v: any, i: number) => {
          const arrKey = `${fullKey}[${i}]`;
          if (typeof v === 'object') return this.getObjectDotsKeys(v, arrKey);
          return arrKey;
        });
      }

      if (typeof value === 'object') return this.getObjectDotsKeys(value, fullKey);
      return fullKey;
    });
  }

  static convertStringCoordinatesToLatLng(coordinates: string) {
    return coordinates.split(' ').map((i) => parseFloat(i));
  }

  static removeFieldsFromObject<T extends { [K in keyof T]: T[K] }, K extends Array<keyof T>>(
    obj: T,
    fields: K,
  ): Omit<T, K[number]> {
    const objCopy: T = JSON.parse(JSON.stringify(obj));

    fields.forEach((field) => {
      delete objCopy[field];
    });

    return objCopy;
  }

  static pickFieldsFromObject = <T extends Record<string, any>>(
    obj: T,
    fieldsToKeep: (keyof T)[],
  ): Partial<T> => {
    return Object.fromEntries(
      Object.entries(obj).filter(([key]) => fieldsToKeep.includes(key as keyof T)),
    ) as Partial<T>;
  };
}
